var _circle, _path, _path2, _path3, _path4, _path5, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5383EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1161 22.4984V10.9843C25.1161 9.92442 24.2569 9.06525 23.1971 9.06525H8.89167C7.83183 9.06525 6.97266 9.92442 6.97266 10.9843V22.4984C6.97266 23.5582 7.83183 24.4174 8.89167 24.4174H23.1971C24.2569 24.4174 25.1161 23.5582 25.1161 22.4984Z",
    stroke: "white",
    strokeWidth: 1.57011
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1161 22.3239V13.95C25.1161 12.7938 24.1788 11.8565 23.0226 11.8565H9.06613C7.90994 11.8565 6.97266 12.7938 6.97266 13.95V22.3239C6.97266 23.4801 7.90994 24.4174 9.06613 24.4174H23.0226C24.1788 24.4174 25.1161 23.4801 25.1161 22.3239Z",
    stroke: "white",
    strokeWidth: 1.57011
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1161 11.5076V10.6354C25.1161 9.76821 24.4132 9.06525 23.546 9.06525H8.54276C7.67562 9.06525 6.97266 9.76821 6.97266 10.6354V11.5076H25.1161Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.57011
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6425 6.97174C12.6425 6.53817 12.291 6.18669 11.8574 6.18669C11.4238 6.18669 11.0724 6.53817 11.0724 6.97174H12.6425ZM11.0724 11.1587C11.0724 11.5923 11.4238 11.9437 11.8574 11.9437C12.291 11.9437 12.6425 11.5923 12.6425 11.1587H11.0724ZM11.0724 6.97174V11.1587H12.6425V6.97174H11.0724Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0155 6.97174C21.0155 6.53817 20.664 6.18669 20.2305 6.18669C19.7969 6.18669 19.4454 6.53817 19.4454 6.97174H21.0155ZM19.4454 11.1587C19.4454 11.5923 19.7969 11.9437 20.2305 11.9437C20.664 11.9437 21.0155 11.5923 21.0155 11.1587H19.4454ZM19.4454 6.97174V11.1587H21.0155V6.97174H19.4454Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.76367,
    y: 14.6478,
    width: 9.76956,
    height: 2.09348,
    rx: 1.04674,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.76367,
    y: 18.137,
    width: 6.28043,
    height: 2.09348,
    rx: 1.04674,
    fill: "white"
  })));
}

export default SvgCalendarThumb;